import { fmtAMD } from '@/lib/format';
import { useI18n } from '@/providers/i18n';
import type { TicketTier } from '@/types';

import QtyStepper from './QtyStepper';
import styles from './TierRow.module.css';

interface TierRowProps {
  tier: TicketTier;
  qty: number;
  onQtyChange: (next: number) => void;
}

export default function TierRow({ tier, qty, onQtyChange }: TierRowProps) {
  const { t } = useI18n();
  const isOut = tier.remaining === 0;
  const selected = qty > 0;

  const handleSelect = () => {
    if (isOut) return;
    if (qty === 0) onQtyChange(1);
  };

  const noteParts = [tier.note];
  if (tier.remaining != null && tier.remaining > 0) {
    noteParts.push(`${tier.remaining} LEFT`);
  }

  return (
    <div
      role="button"
      tabIndex={isOut ? -1 : 0}
      className={styles.root}
      data-selected={selected}
      data-disabled={isOut}
      onClick={handleSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleSelect();
        }
      }}
    >
      <span className={styles.radio} aria-hidden="true" />
      <div>
        <div className={styles.name}>{tier.name}</div>
        <div className={styles.note}>{noteParts.join(' · ')}</div>
      </div>
      <span className={styles.price}>{fmtAMD(tier.price)}</span>
      {isOut ? (
        <span className={styles.note}>{t('state.soldout')}</span>
      ) : (
        <QtyStepper value={qty} onChange={onQtyChange} />
      )}
      <span className={styles.note}>{qty > 0 ? fmtAMD(qty * tier.price) : '—'}</span>
    </div>
  );
}
